import React from "react";
import styled from "styled-components";

const HeroSection = ({ onJoinClick }) => {
  const imagePath = `${process.env.PUBLIC_URL}/media/user_images/welcomeRightUpper-min.jpg`;
  return (
    <HeroWrapper>
      <TextContent>
        <h1>Empower Saving. Simplify Borrowing.</h1>
        <p>Join EYE20 GROUP to build wealth with community-driven contributions and loans.</p>
        <CTA onClick={onJoinClick}>Join Now</CTA>
      </TextContent>
      <HeroImg src={imagePath} alt="finance" />

    </HeroWrapper>
  );
};

const HeroWrapper = styled.section`
  padding: 3rem 2rem;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  gap: 2rem;

  @media(min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

const TextContent = styled.div`
  max-width: 600px;
  h1 {
    font-size: 2rem;
    color: #003366;
    margin-bottom: 1rem;
  }
  p {
    font-size: 1.125rem;
    color: #555;
    margin-bottom: 1.5rem;
  }
`;

const CTA = styled.button`
  padding: 0.75rem 1.5rem;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: bold;
  font-size: 1rem;
  cursor: pointer;

  &:hover {
    background: #005dc1;
  }
`;

const HeroImg = styled.img`
  max-width: 400px;
  width: 100%;
`;

export default HeroSection;
